import styled from '@emotion/styled'
import { rpMediaQueries } from '../../core/theme'
import img from './img/pattern_seamless.png'

export const sizeSidePanel = {
  mobile: 120,
  tablet: 200,
  desktop: 300,
}

export const Container = styled.div`
  width: 100%;
  height: 100%;
  font-family: 'SF Pro Display', sans-serif;
  background: black;
  line-height: normal;
  display: grid;
  grid-template-columns: 1fr ${sizeSidePanel.mobile}px;
  background: url(${img}) repeat;
  position: relative;

  @supports (top: env(safe-area-inset-top)) {
    padding-top: max(8px + env(safe-area-inset-top));
    padding-right: max(8px + env(safe-area-inset-right));
    padding-left: max(8px + env(safe-area-inset-left));
    padding-bottom: max(8px + env(safe-area-inset-bottom));
  }

  ${rpMediaQueries.tablet} {
    grid-template-columns: 1fr ${sizeSidePanel.tablet}px;

    @supports (top: env(safe-area-inset-top)) {
      padding-top: max(12px + env(safe-area-inset-top));
      padding-right: max(12px + env(safe-area-inset-right));
      padding-left: max(12px + env(safe-area-inset-left));
      padding-bottom: max(12px + env(safe-area-inset-bottom));
    }
  }
`
